export const COMMENT_SECTION_ID = "comments";
export const REACTION_SECTION_ID = "reactions";
export const LIKE_SECTION_ID = "likes";
